export const DELIVERY_PRICE_WITHOUT_ONSITE_SETUP: number = 10;
export const ONSITE_SETUP_PRICE: number = 10;
export const SHORT_TIME_WINDOW_PRICE: number = 10;

export const ORDER_MIN_AMOUNT: number = 60;
export const ORDER_BAKERY_MIN_AMOUNT: number = 15;
export const ORDER_DRY_MIN_AMOUNT: number = 40;
export const ORDER_FRESH_MIN_AMOUNT: number = 20;
export const ORDER_FRUIT_MIN_AMOUNT: number = 25;
export const ORDER_CATERER_MIN_AMOUNT: number = 20;
